import { ApiRequestConfig } from 'api';
import { get } from 'features/api';
import { LinkedPagesParams, LinkedPagesResponse } from '../types';

export const fetchLinkedPages = (params: LinkedPagesParams, options: ApiRequestConfig) =>
  get<LinkedPagesResponse>('linked-pages', params, options);
